import { DenormalizedBulkOrder } from '@packages/types'
import React from 'react'

import useThemeSettings from 'customizer/theme/useThemeSettings'
import BulkOrderEditButton from 'themes/common/components/bulkOrder/BulkOrderEditButton'
import SanitizedHtml from 'themes/common/components/SanitizedHtml'

import './BulkOrderStepHeader.scss'

interface BulkOrderStepHeaderProps {
  bulkOrder: DenormalizedBulkOrder
}

const BulkOrderStepHeader = ({ bulkOrder }: BulkOrderStepHeaderProps) => {
  const questionStyle = useThemeSettings('question')

  return (
    <div className="step">
      <div
        className="step__header bulk-order-step-header"
        style={{
          borderBottomColor: questionStyle.dividerColor,
          borderBottomWidth: questionStyle.dividerWidth,
          paddingBottom: questionStyle.dividerWidth === '0px' ? '0' : '0.5rem',
        }}
      >
        <div
          className="step__header-title bulk-order-step-header__title"
          style={{
            color: questionStyle.questionFontColor,
            fontSize: questionStyle.questionFontSize,
            fontFamily: questionStyle.questionFontFamily?.fontFamily,
          }}
        >
          {bulkOrder?.name}
          <BulkOrderEditButton />
        </div>
      </div>
      {bulkOrder.description && bulkOrder.showDescription && (
        <SanitizedHtml
          dirtyHtml={bulkOrder.description}
          className="step__description"
          style={{
            color: questionStyle.descriptionFontColor,
            fontSize: questionStyle.descriptionFontSize,
            fontFamily: questionStyle.descriptionFontFamily?.fontFamily,
          }}
        />
      )}
    </div>
  )
}

export default BulkOrderStepHeader
